export const settings = {
  setShareTitle: 'Sdílet aplikaci',
  setNotifiationsTitle: 'Oznámení',
  setContactAppOwnerTitle: 'Kontaktovat majitele aplikace',
  setContactDevelopersTitle: 'Kontaktovat vývojáře',
  setReportAppTitle: 'Nahlásit aplikaci',
  setDeleteAccountTitle: 'Smazat účet',
  setLogOutTitle: 'Odhlásit se',
  setShareAppCurtainTitle: 'Sdílet aplikaci',
  setShareAppCurtainButtonTitle: 'Zkopírovat odkaz',
  setShareAppAlertWhenAppLinkWasCopied: 'Odkaz zkopírován!',
  setNotificationsInAppTitle: 'V aplikaci',
  setNotificationsPushContent: 'Push',
  setNotificationsChatsTitle: 'Chaty',
  setNotificationsDiscussionsTitle: 'Diskuze',
  setNotificationsNewsTitle: 'Novinky',
  setNotificationsEventsTitle: 'Události',
  setNotificationsAdminTitle: 'Zprávy od správce',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Push notifikace jsou vypnuty',
  setNotificationsPushOffText: 'Pro povolení notifikací přejděte do nastavení svého zařízení a povolte notifikace',
  setReportAppFlagCurtainTitle: 'Nahlásit',
  setAppReportedCurtainContent: 'Obsah byl nahlášen',
  setDeleteCurtainTitle: 'Smazat účet',
  setDeleteCurtainInputContent: 'Heslo',
  setDeleteCurtainCancelButtonTitle: 'Zrušit',
  setDeleteCurtainConfirmButtonTitle: 'Potvrdit',
  setDeleteCurtainIncorrectPasswordAlertText: 'Heslo je nesprávné',
  setTurnNotificationsOnText: 'Pro povolení notifikací klikněte na tlačítko níže a povolte příjem notifikací.',
  setTurnNotificationsOnButton: 'Zapnout push notifikace'
}
